const Entities = require('html-entities').AllHtmlEntities;
const entities = new Entities();

module.exports = {
  name: 'singlestopinfo',
  props: {
    singleStopInfo: {
      type: Object,
      required: true,
    },
  },

  created: function () {
    // console.log(this.singleStopInfo);
  },

  render() {
    return (
      <div class="stop-name__info">
        {this.singleStopInfo.expanded_information !== '' &&
          <div class="hover-pop-up">
            <div class="hover-pop-up__body hover-pop-up__body--left-align" domPropsInnerHTML={`<span class="title">Info:</span><span>${this.singleStopInfo.expanded_information}</span>`} />
            <div class="hover-pop-up__icon icon-clipboard"></div>
          </div>

        }

        {this.singleStopInfo.stop_description !== '' &&
          <div class="hover-pop-up">
            <div class="hover-pop-up__body hover-pop-up__body--left-align" domPropsInnerHTML={`<span class="title">Description:</span><span>${entities.decode(this.singleStopInfo.stop_description)}</span>`} />
            <div class="hover-pop-up__icon icon-info"></div>
          </div>
        }

        {this.singleStopInfo.connecting_stop === 'True' &&
          <div class="hover-pop-up">
            <div class="hover-pop-up__body hover-pop-up__body--left-align"
              domPropsInnerHTML={`<span class="title">${this.singleStopInfo.connection_info !== '' ? 'Connection:' : 'Connecting Stop'}</span><span>${this.singleStopInfo.connection_info}</span>`} />
            <div class="hover-pop-up__icon icon-connection-arrows"></div>
          </div>
        }
      </div>
    );
  },
};
